/* 🤖 this file was generated by svg-to-ts */
export const matIconGridGoldenratio: {
  name: 'grid-goldenratio';
  data: string;
} = {
  name: 'grid-goldenratio',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M22 11V9h-7V2h-2v7h-2V2H9v7H2v2h7v2H2v2h7v7h2v-7h2v7h2v-7h7v-2h-7v-2h7zm-9 2h-2v-2h2v2z"/></svg>`
};
